<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle" v-if="langCode === 'id'">Pilih file untuk download</h4>
        <h4 class="modalTitle" v-if="langCode === 'en'">Select file to download</h4>
        <div class="selectorCnt">
          <div v-on:click="close(item, item.media, item.media.uri)"
            v-for="(item, i) in attachments" :key="i" class="selectorItem">
            <h4>{{item.media.filename}}</h4>
          </div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'shareDialog',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      attachments: [],

      /**
       * Language
       *
       */
      loadingLang: true,
      langCode: 'id',
      lang: null,
    };
  },
  methods: {
    open(d, next) {
      this.attachments = d || [];
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
  mounted() {
    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px 30px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 400px;
      max-width: 100%;
      @media (max-width: 680px) {
        width: calc(100% - 20px);
      }
      .close{
        position: absolute;
        right: 6px; top: 6px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      .modalTitle{
        padding: 20px 40px 10px;
        font-size: 20px;
        margin: -30px -40px 20px;
        font-weight: 400;
        text-align: left;
        @media (max-width: 680px) {
        }
      }
      .selectorCnt{
        .selectorItem{
          padding: 12px 20px 10px;
          padding-left: 80px;
          margin: 0 -40px;
          transition: all .2s ease;
          position: relative;
          display: block;
          &:before{
            content: "";
            position: absolute;
            left: 40px; top: 0; bottom: 6px; width: 20px;
            background-image: url(../assets/download-icon.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: #444;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 20px;
            text-overflow: ellipsis;
            span.hd{
              color: red;
              padding-left: 4px;
            }
          }
        }
      }
    }
  }
</style>
